import { Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from '../../../WeissmanModalService';
import { ReturnLoadDataActions } from '../../Models/enums';

export interface ReturnLoadDataModalResult {
    action: ReturnLoadDataActions;
}

/**
 * Confirms whether the user wishes to mark the load data task complete, or skip it.
 * Mirrors the complete/skip pattern used by ReturnSignModalComponent for the digitally
 * sign returns task.
 */
@Component({
    selector: 'return-load-data-modal',
    templateUrl: './returnLoadDataModal.component.html',
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class ReturnLoadDataModalComponent implements IWeissmanModalComponent<void, ReturnLoadDataModalResult> {
    constructor(private readonly _bsModalRef: BsModalRef) {
    }

    params: void;
    result: ReturnLoadDataModalResult;

    complete(): void {
        this.result = {
            action: ReturnLoadDataActions.Complete
        };

        this._bsModalRef.hide();
    }

    skip(): void {
        this.result = {
            action: ReturnLoadDataActions.Skip
        };

        this._bsModalRef.hide();
    }

    cancel(): void {
        this._bsModalRef.hide();
    }
}
